import React from 'react';
import PropTypes from 'prop-types';

import ThresholdGroup from './threshold-group';


const ThresholdVisualizer = ({ data, options }) => {
  const { showThresholdOnly } = options;
  const items = data[0].map(d => (
    <ThresholdGroup
      key={d.name}
      name={d.name}
      values={d.values}
      showThresholdOnly={showThresholdOnly}
    />
  ));


  return (
    <div>
      {items}
    </div>
  );
};

ThresholdVisualizer.propTypes = {
  data: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
};

export default ThresholdVisualizer;
